import { IUserAttribute } from './../shared/interfaces/user-attributes.interface';
import { ajax } from '@setel/webcommon/exposes/ajax';
import { environments } from 'environments/environment';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/attributes`;

export const getUserAttributes = ({
  userId,
  entityType = 'users',
}: {
  userId: string;
  entityType?: string;
}): Promise<IUserAttribute> =>
  ajax.get<IUserAttribute>(`${BASE_URL}/admin/entity`, {
    params: { entityId: userId, entityType },
  });
